import axios from "axios";
import { toast } from "react-toastify";
import DecryptData from "../utils/Decrypt";

const getAuthKey = () => {
  const tokenString = localStorage.getItem("nEkOtResU");
  if (tokenString) {
    return DecryptData("nEkOtResU");
  } else {
    return "";
  }
};

const axiosInstance = axios.create({
  baseURL: window.WEB_APP_API_URL,
  // headers: {
  //   token: getAuthKey() || "",
  // },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthKey();
    if (token) {
      config.headers.token = token;
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) =>
    new Promise((resolve, reject) => {
      if (
        response.data.message === "Token is invalid" ||
        response.data.message === "Token is missing"
      ) {
        toast.warning(response.data.message);
        window.localStorage.removeItem("aTaDrEsU");
        window.localStorage.removeItem("nOiSsImRePrEsU");
        window.localStorage.removeItem("yEkSseCcaReSu");
        window.localStorage.removeItem("nEkOtResU");
        window.location = `/auth/login`;
      } else {
        resolve(response);
      }
    }),
  (error) => {
    if (!error.response) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }

    if (error.response.status === 401) {
      window.localStorage.removeItem("aTaDrEsU");
      window.localStorage.removeItem("nOiSsImRePrEsU");
      window.localStorage.removeItem("yEkSseCcaReSu");
      window.localStorage.removeItem("nEkOtResU");
      window.location = `/auth/login`;
    } else {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  },
);

export default axiosInstance;
